module.exports = __webpack_public_path__ + "static/media/SF-Logo.17f38dbd.png";